var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"price-display"},[(_vm.showOriginalPrice)?_c('price-format',{staticClass:"price-format--original",attrs:{"currency":_vm.displayCode,"price":_vm.originalDisplayPrice,"show-code":_vm.showCode}}):_vm._e(),_vm._v(" "),_c('price-format',{attrs:{"currency":_vm.displayCode,"price":_vm.displayPrice,"show-code":_vm.showCode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }